import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartItemResponse } from './multiCartMappers'
import { arrayToObject } from 'lib/array/arrayUtils'
import type { MachineContext } from 'typings/app/machineContext'

type FetchSuccess = paths['/api/carts/multi-carts/{multiCartId}/items']['get']['responses']['200']['content']['application/json']

export async function getMultiCartItems(cartId: string): Promise<MachineContext.CartItems> {
  const multiCartItems = await request.get<FetchSuccess>(`/api/carts/multi-carts/${cartId}/items`, { credentials: 'include' }).then(mapMultiCartItemResponse)
  return { [cartId]: arrayToObject(multiCartItems, item => item.id) }
}
